import { graphql } from 'gatsby';
import { Box } from '@twilio-paste/box';
import { Flex } from '@twilio-paste/flex';
import { Heading } from '@twilio-paste/heading';
import { Paragraph } from '@twilio-paste/paragraph';
import { SidebarCategoryRoutes } from "../../../../src/constants";
import { Callout, CalloutText } from "../../../../src/components/callout";
import { DoDont, Do, Dont } from "../../../../src/components/DoDont";
import Changelog from '@twilio-paste/flex/CHANGELOG.md';
import * as React from 'react';
export default {
  graphql,
  Box,
  Flex,
  Heading,
  Paragraph,
  SidebarCategoryRoutes,
  Callout,
  CalloutText,
  DoDont,
  Do,
  Dont,
  Changelog,
  React
};